<template>
  <v-container>
    <h1>{{ get("contact")}}</h1>
    <div>
      <a @click="onHome">
        <v-img
          src="@/assets/aquaduct.jpg"
          height="82"
          width="508"
          min-height="82"
          min-width="508"
        >
        </v-img>
      </a>
    </div>
    <br />
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12">
            <p>
              {{ get("p-1.1") }} 
              {{ get("company") }} 
              {{ get("p-1.2") }}
              <phonenumber phone="(303) 784-8010"></phonenumber>
              {{ get("p-1.3") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>{{ get("header-1") }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            xl="4"
            lg="4"
            md="6"
            sm="12"
            v-for="place in locations"
            v-bind:key="place.city"
          >
            <v-card>
              <v-card-title>{{ place.city }}</v-card-title>
              <v-card-subtitle v-if="place.phone.length > 0">
                <phonenumber :phone="place.phone"></phonenumber>
              </v-card-subtitle>
              <v-card-text>
                <p v-if="place.address.length > 0">
                  {{ place.address }} <br />
                </p>
                <p v-if="place.city.length > 0">
                  {{ place.city }}, {{ place.state }} {{ place.zipcode }} <br />
                </p>
                <p v-if="place.hours.length > 0">{{ place.hours }}<br /></p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import LocationService from "@/_services/location-service";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "contact",

  components: {
    estimate,
    phonenumber,
  },

  created() {
    this.pageName = "contact";
    this.locations = LocationService.getLocations();
  },

  data: () => ({
    locations: [],
  }),

  mixins: [localizationMixin],

  methods: {
    onHome() {
      if(this.$route.path != "/") {
        this.$router.push("/")
      }
    },
    getLocalization(){}
  }
};
</script>

<style>
.v-application p {
  margin-bottom: 0px;
}
</style>
